var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group", attrs: { id: _vm.id } }, [
    _c("div", { staticClass: "form-row" }, [
      _c(
        "div",
        {
          staticClass: "col toggleFilters",
          class: { "is-open": _vm.show_more },
          on: { click: _vm.toggleFilters }
        },
        [
          _c(
            "span",
            {
              staticClass: "range-control-label",
              class: { "font-weight-bold ": _vm.placeholder }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm._f("capitalize")(
                      _vm.placeholder
                        ? _vm.placeholder
                        : _vm.labels[_vm.mainLabel]
                    )
                  ) +
                  "\n            "
              )
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show_more,
            expression: "show_more"
          }
        ],
        staticClass: "range-control-filters"
      },
      [
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "form-row" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("my-input", {
                  ref: _vm.minValueKey,
                  attrs: {
                    label: _vm.labels[_vm.minValueKey],
                    min: _vm.min,
                    secondary: ""
                  },
                  on: {
                    focus: function($event) {
                      return _vm.selectRange("min")
                    },
                    input: function($event) {
                      return _vm.formatValue($event, "min_value")
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.toggleFilters.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.min_value,
                    callback: function($$v) {
                      _vm.min_value = $$v
                    },
                    expression: "min_value"
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.numeric_min_value,
                      expression: "numeric_min_value"
                    }
                  ],
                  attrs: { name: _vm.minValueKey, type: "hidden" },
                  domProps: { value: _vm.numeric_min_value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.numeric_min_value = $event.target.value
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("my-input", {
                  ref: _vm.maxValueKey,
                  attrs: {
                    label: _vm.labels[_vm.maxValueKey],
                    min: _vm.min,
                    secondary: ""
                  },
                  on: {
                    focus: function($event) {
                      return _vm.selectRange("max")
                    },
                    input: function($event) {
                      return _vm.formatValue($event, "max_value")
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.toggleFilters.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.max_value,
                    callback: function($$v) {
                      _vm.max_value = $$v
                    },
                    expression: "max_value"
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.numeric_max_value,
                      expression: "numeric_max_value"
                    }
                  ],
                  attrs: { name: _vm.maxValueKey, type: "hidden" },
                  domProps: { value: _vm.numeric_max_value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.numeric_max_value = $event.target.value
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.defaultValues
              ? _c(
                  "div",
                  {
                    staticClass: "col-12 default-value",
                    attrs: { tabindex: "0" },
                    on: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.toggleFilters.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.show_default_value_min,
                            expression: "show_default_value_min"
                          }
                        ],
                        ref: "default_value_min",
                        staticClass: "default-value-min"
                      },
                      [
                        _c(
                          "ul",
                          _vm._l(_vm.defaultValues.values, function(
                            default_value,
                            key
                          ) {
                            return key >= _vm.default_range_min_value &&
                              key <= _vm.default_range_max_value
                              ? _c(
                                  "li",
                                  {
                                    key: key,
                                    ref:
                                      _vm.min_value == default_value
                                        ? "default_range_min_selected"
                                        : null,
                                    refInFor: true,
                                    class:
                                      _vm.min_value == default_value
                                        ? "selected"
                                        : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectDefaultValue(
                                          default_value,
                                          "min"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(_vm._s(default_value) + " "),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.defaultValues.unit
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.show_default_value_max,
                            expression: "show_default_value_max"
                          }
                        ],
                        ref: "default_value_max",
                        staticClass: "default-value-max"
                      },
                      [
                        _c(
                          "ul",
                          _vm._l(_vm.defaultValues.values, function(
                            default_value,
                            key
                          ) {
                            return key >= _vm.default_range_min_value &&
                              key <= _vm.default_range_max_value
                              ? _c(
                                  "li",
                                  {
                                    key: key,
                                    ref:
                                      _vm.max_value == default_value
                                        ? "default_range_max_selected"
                                        : null,
                                    refInFor: true,
                                    class:
                                      _vm.max_value == default_value
                                        ? "selected"
                                        : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectDefaultValue(
                                          default_value,
                                          "max"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(_vm._s(default_value) + " "),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.defaultValues.unit
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          }),
                          0
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }